module.exports = __webpack_public_path__ + "media/Heat_OUT.c57049a4.mp4";